import {IGroupMember, IGroupParticipant} from '../models/interfaces';

interface IMapParticipantsToMembersParams {
  participants: IGroupParticipant[];
  currentUserId?: string;
  ownerId?: string;
  t?: (key: string) => string;
}

export const mapParticipantsToMembers = (
  params: IMapParticipantsToMembersParams,
): IGroupMember[] => {
  if (!params?.participants) return [];
  return params.participants.map(participant => ({
    id: participant.splitUserId,
    name: participant.name,
    description: participant.validated
      ? ''
      : params.t?.('groups.dashboard.invite_pending') ?? '',
    isOwner: params.ownerId
      ? participant.splitUserId === params.ownerId
      : false,
    isYou: params.currentUserId === participant.splitUserId,
  }));
};
